export default {
  presets: {
    light: {
      backgroundPrimary: '#EDF0F4',
      backgroundSecondary: '#F5F6F8',
      backgroundCardPrimary: '#F8F9FB',
      backgroundCardSecondary: '#ECFDE6',
      primary: '#315FA8',
      textPrimary: '#263244',
      textSecondary: '#657286',
      backgroundElement: '#F8F9FB',
      backgroundBorder: '#D9DEE7',
      success: '#397A56',
      info: '#397DA8',
      danger: '#B94C50',
      warning: '#D3A746',
    },
    dark: {
      backgroundPrimary: '#0B1220',
      backgroundSecondary: '#111827',
      backgroundCardPrimary: '#1E293B',
      backgroundCardSecondary: '#243B65',
      primary: '#4F8CFF',
      textPrimary: '#F1F5F9',
      textSecondary: '#94A3B8',
      backgroundElement: '#172235',
      backgroundBorder: '#334155',
      success: '#4ADE80',
      info: '#60A5FA',
      danger: '#F87171',
      warning: '#FBBF24',
    },
  },
}
